/**
 * Verticaly URL Redirects
 * Consolidated redirect logic for cleaner theme.liquid
 * Created: 2025-11-26
 */
(function() {
  'use strict';
  
  var path = window.location.pathname.replace(/\/+$/, '');
  var search = window.location.search || '';
  var hash = window.location.hash || '';
  var lang = (document.documentElement && document.documentElement.lang) || '';
  var isEn = (path === '/en') || path.startsWith('/en/');
  
  // Helper function
  function redirect(target) {
    window.location.replace(target);
  }
  
  // 1. Help redirect: /help → /pages/help
  if (path === '/help' || path === '/en/help') {
    redirect('https://verticaly.co' + (path === '/en/help' ? '/en/pages/help' : '/pages/help') + search + hash);
    return;
  }
  
  // 2. Subscription redirect
  var isEnSub = path === '/en/subscription' || path === '/en/subscription/' || path === '/en/collections/subscription';
  if (path === '/subscription' || path === '/subscription/' || isEnSub || path === '/collections/subscription') {
    redirect('https://verticaly.co' + (isEnSub ? '/en/pages/subscription' : '/pages/subscription') + search + hash);
    return;
  }
  
  // 3. Login redirect
  if (path === '/login' || path === '/collections/login' || path === '/en/login' || path === '/en/collections/login') {
    redirect('https://verticaly.co/account/login' + search + hash);
    return;
  }
  
  // 4. Cart redirect (only for /collections/cart paths, not /en/cart)
  if (path === '/collections/cart') {
    redirect('https://verticaly.co/cart' + search + hash);
    return;
  }
  if (path === '/en/collections/cart') {
    redirect('https://verticaly.co/en/cart' + search + hash);
    return;
  }
  
  // 5. Favorites redirect (English UI but Japanese path)
  if (lang.indexOf('en') === 0 && (path === '/pages/favorites' || path === '/favorites')) {
    redirect('https://verticaly.co/en/pages/favorites' + search + hash);
    return;
  }
  
  // 6. Collection handle normalization (/seasonal-events → /collections/seasonal-events)
  var bodyPath = isEn ? path.replace(/^\/en/, '') : path;
  var isKnown = (
    bodyPath === '' ||
    bodyPath === '/' ||
    bodyPath.startsWith('/pages') ||
    bodyPath.startsWith('/account') ||
    bodyPath.startsWith('/products') ||
    bodyPath.startsWith('/cart') ||
    bodyPath.startsWith('/search') ||
    bodyPath.startsWith('/blogs') ||
    bodyPath.startsWith('/news') ||
    bodyPath.startsWith('/apps') ||
    bodyPath.startsWith('/collections')
  );
  
  if (!isKnown) {
    redirect('https://verticaly.co' + (isEn ? '/en' : '') + '/collections' + bodyPath + search + hash);
    return;
  }
})();

